// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// vue
import Vue from 'vue'
// app
import App from './App'
// router
import router from './router'
// store
import store from './store'
// Create VueI18n instance with options
import i18n from './plugins/i18n'
// middleware
import middleware from './middleware'
// Global Mixin
import mixin from './mixin'
// momentjs
import moment from 'moment'

// detect a browser vendor and version
import { detect } from 'detect-browser'

// device-detector
import { devices } from './lib/device-detector'

// config project
import project from '@/project'
import './plugins/composition'

/**
 ** Vue config
 **/
// set production tip
Vue.config.productionTip = false

// this only work for production
if (project.config.node_env === 'production') {

}

// set moment i18n
moment.locale(store.state.app.lang)

/**
 ** Vue middleware
 **/
router.beforeEach(middleware)

/**
 ** Vue mixin is global can use for all page
 **/
Vue.mixin(mixin)

// add vue prototype
Vue.prototype.moment = moment
Vue.prototype.browser = detect()
Vue.prototype.mixin = mixin.methods
Vue.prototype.project = project
Vue.prototype.device = devices()

// disabled all console
if (!project.config.debug) {
  var methods = ['log', 'warn'] // type of console to disable
  for (var i = 0; i < methods.length; i++) {
    console[methods[i]] = function () {}
  }
}

/**
 ** Import CSS Files
 **/
require('./assets/css/style.css')
require('./assets/css/print/style-1.css')

/**
 ** Import JS Files
 **/
require('./assets/js/ui.js')
require('./assets/js/printThis.js')

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js